module.exports = __webpack_public_path__ + "img/maternity.07ad242e.svg";